// Paletas precargadas de "Alba" (bautismo): tonos tiernos y luminosos.
const FUENTES = {
  display: '"Cormorant Garamond", Georgia, serif',
  cuerpo: '"Karla", system-ui, sans-serif',
};

export const paletas = [
  {
    clave: "cielo",
    nombre: "Cielo",
    tema: {
      colores: {
        fondo: "#F6F9FB",
        fondoAlt: "#EBF1F6",
        texto: "#22313D",
        textoSuave: "#4E6070",
        textoTenue: "#8DA0AE",
        primario: "#3D5A73",
        primarioSuave: "#DDE8F1",
        acento: "#7FA3C0",
        borde: "rgba(61, 90, 115, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "petalo",
    nombre: "Pétalo",
    tema: {
      colores: {
        fondo: "#FBF6F6",
        fondoAlt: "#F5EBEA",
        texto: "#3D2630",
        textoSuave: "#6B4E58",
        textoTenue: "#A98E97",
        primario: "#7A4A5C",
        primarioSuave: "#F2E1E6",
        acento: "#C08CA0",
        borde: "rgba(122, 74, 92, 0.16)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "lino",
    nombre: "Lino bautismal",
    tema: {
      colores: {
        fondo: "#FAF7F1",
        fondoAlt: "#F2ECDF",
        texto: "#33302A",
        textoSuave: "#5F594C",
        textoTenue: "#9A917E",
        primario: "#6B5B3E",
        primarioSuave: "#EDE4D2",
        acento: "#B49A67",
        borde: "rgba(107, 91, 62, 0.18)",
      },
      fuentes: FUENTES,
    },
  },
];
